import * as React from 'react';

import styles from './zoom_buttons.css';
import { MinusIcon, PlusIcon } from '../../common/icons';

export interface IZoomButtonsProps {
  max: number;
  min: number;
  step: number;
  value: number;
  onChange(value: number): void;
}

export class ZoomButtons extends React.Component<IZoomButtonsProps, object> {
  public render() {
    const { props } = this;

    return (
      <div className={styles['buttons']}>
        <button className={styles['button']} disabled={props.value >= props.max} onClick={this.plus}>
          <span className={styles['plus']}>
            <PlusIcon />
          </span>
        </button>
        <button className={styles['button']} disabled={props.value <= props.min} onClick={this.minus}>
          <span className={styles['minus']}>
            <MinusIcon />
          </span>
        </button>
      </div>
    );
  }

  private plus: React.MouseEventHandler<HTMLElement> = event => {
    event.preventDefault();
    event.stopPropagation();
    const { props } = this;
    props.onChange(Math.min(props.max, props.value + props.step));
  };

  private minus: React.MouseEventHandler<HTMLElement> = event => {
    event.preventDefault();
    event.stopPropagation();
    const { props } = this;
    props.onChange(Math.max(props.min, props.value - props.step));
  };
}
